export const GET_ALL_PAYOUT_LOGS = 'GET_ALL_PAYOUT_LOGS'
export const GET_ALL_TRANS_LOGS = 'GET_ALL_TRANS_LOGS'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_ALL_TRANS_LOGS_ZB = 'GET_ALL_TRANS_LOGS_ZB'
export const GET_ALL_PAYOUT_LOGS_ZB = 'GET_ALL_PAYOUT_LOGS_ZB'
